import React from 'react';

import './../styles/floor-mat-product-selector.css';

import { useFloorMatStore } from '../stores/floor-mat-store';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { formatMoney, getNewShopifyImageSize } from '../utils/helpers';

function FloorMatProductSelector() {
  const matOptions = useFloorMatStore(state => state.matOptions);
  const selectedMatOptions = useFloorMatStore(state => state.selectedMatOptions);
  const setSelectedMatOptions = useFloorMatStore(state => state.setSelectedMatOptions);
  const setSelectedMatOptionUnique = useFloorMatStore(state => state.setSelectedMatOptionUnique);

  const handleFloorMatOptionUniqueChange = (e, option) => {
    e.preventDefault();
    e.stopPropagation();
    const selectedOptionUnique = e.target.value;

    setSelectedMatOptionUnique(selectedOptionUnique, option);
  }

  console.log('selectedMatOptions', selectedMatOptions);

  return (
    <section className="floor-mat-product-options-container">
      {matOptions?.map(option => {
        const isSelected = !!selectedMatOptions.find(o => o.id === option.id);
        return (
          <div
            key={option.partNumber}
            className={`floor-mat-product-option-container ${isSelected ? 'is-selected' : ''}`}
          >
            <div onClick={() => setSelectedMatOptions(option)} className="floor-mat-product-option">
              <img
                src={getNewShopifyImageSize({ width: 200, height: 200, imageUrl: option?.featured_image?.src })}
                alt={`${option?.title} Image`}
              />
              <p className="floor-mat-product-option-title">
                {option?.title}
              </p>
              <p className="floor-mat-product-option-price">
                {formatMoney(option?.price / 100)}
              </p>
            </div>
            {!!option.product_unique_list?.length && (
              <FormControl fullWidth className="car-model-form-control">
                <InputLabel id="floor-mat-option-label">Select Option</InputLabel>
                <Select
                  labelId="floor-mat-option-label"
                  id="floor-mat-option"
                  value={option.selectedProductUnique}
                  label="Select Option"
                  onChange={(e) => handleFloorMatOptionUniqueChange(e, option)}
                  className="floor-mat-option-select"
                >
                  {option.product_unique_list?.map(o => (
                    <MenuItem key={o.brand_application_code} value={o}>{o.product_unique_string}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
        )
      })}
    </section>
  )
}

export default FloorMatProductSelector
